import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {isAddonPermissionDefined} from 'app/store/reducers/user_settings.reducer';
import {filter, map, switchMap} from 'rxjs';
import {AddonPermissionService} from './addon-permission.service';

@Injectable({ providedIn: 'root' })
export class AddonPermissionGuard {
  constructor(private router: Router, private addonsPermissionService: AddonPermissionService, private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const key = route.data.addon_key;
    return  this.store.select(isAddonPermissionDefined).pipe(
      filter((isFetch: boolean) => {
        return isFetch == true;
      }),
      switchMap(( ) => {
        return this.addonsPermissionService.getAddonPermission(key).pipe(
              map(hasPermission => {
                if(hasPermission){
                    return true;
                }
                this.router.navigate(['dashboard']);
                return false; 
          }) 
        );
      })
    )
  }

}
